import React, { useState } from 'react';
import {
  Box,
  Button,
  Container,
  TextField,
  Typography,
  Link,
  Paper,
  Grid,
  IconButton,
  InputAdornment,
  useTheme,
  useMediaQuery,
  MobileStepper,
  Fade,
  Zoom
} from '@mui/material';
import {
  Visibility,
  VisibilityOff,
  Apple as AppleIcon,
  Google as GoogleIcon,
  Facebook as FacebookIcon,
  Twitter as TwitterIcon,
  LinkedIn as LinkedInIcon,
  MoreHoriz as MoreHorizIcon
} from '@mui/icons-material';
import { keyframes, styled } from '@mui/material/styles';
import SwipeableViews from 'react-swipeable-views';
import { autoPlay } from 'react-swipeable-views-utils';

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

// Styled components
const SocialButton = styled(IconButton)(({ theme }) => ({
  margin: theme.spacing(0.5),
  borderRadius: '8px',
  padding: '8px',
  border: `1px solid ${theme.palette.grey[300]}`,
  transition: 'all 0.3s ease',
  '&:hover': {
    transform: 'scale(1.1)',
    boxShadow: theme.shadows[2]
  }
}));

const LogoText = styled(Typography)(({ theme }) => ({
  fontWeight: 'bold',
  letterSpacing: 1,
  marginBottom: theme.spacing(2),
  transition: 'all 0.3s ease',
  '&:hover': {
    transform: 'scale(1.05)'
  }
}));

const waveGradient = keyframes`
  0% {
    background-position: 0% 0%;
  }
  50% {
    background-position: 100% 100%;
  }
  100% {
    background-position: 0% 0%;
  }
`;


const carouselItems = [
  {
    label: 'MFA for all accounts',
    description: 'Secure online accounts with OneAuth 2FA. Back up OTP secrets and never lose access to your accounts.',
    imgPath: '/api/placeholder/360/240',
    buttonText: 'Learn More',
  },
  {
    label: 'Secure Password Manager',
    description: 'Store all your passwords securely and access them across all your devices.',
    imgPath: '/api/placeholder/360/240',
    buttonText: 'Explore Features',
  },
  {
    label: 'Easy Team Collaboration',
    description: 'Share access securely with team members without compromising security.',
    imgPath: '/api/placeholder/360/240',
    buttonText: 'Get Started',
  }, {
    label: 'MFA for all accounts',
    description: 'Secure online accounts with OneAuth 2FA. Back up OTP secrets and never lose access to your accounts.',
    imgPath: '/api/placeholder/360/240',
    buttonText: 'Learn More',
  }, {
    label: 'MFA for all accounts',
    description: 'Secure online accounts with OneAuth 2FA. Back up OTP secrets and never lose access to your accounts.',
    imgPath: '/api/placeholder/360/240',
    buttonText: 'Learn More',
  }, {
    label: 'MFA for all accounts',
    description: 'Secure online accounts with OneAuth 2FA. Back up OTP secrets and never lose access to your accounts.',
    imgPath: '/api/placeholder/360/240',
    buttonText: 'Learn More',
  }, {
    label: 'MFA for all accounts',
    description: 'Secure online accounts with OneAuth 2FA. Back up OTP secrets and never lose access to your accounts.',
    imgPath: '/api/placeholder/360/240',
    buttonText: 'Learn More',
  }, {
    label: 'MFA for all accounts',
    description: 'Secure online accounts with OneAuth 2FA. Back up OTP secrets and never lose access to your accounts.',
    imgPath: '/api/placeholder/360/240',
    buttonText: 'Learn More',
  }, {
    label: 'MFA for all accounts',
    description: 'Secure online accounts with OneAuth 2FA. Back up OTP secrets and never lose access to your accounts.',
    imgPath: '/api/placeholder/360/240',
    buttonText: 'Learn More',
  }, {
    label: 'MFA for all accounts',
    description: 'Secure online accounts with OneAuth 2FA. Back up OTP secrets and never lose access to your accounts.',
    imgPath: '/api/placeholder/360/240',
    buttonText: 'Learn More',
  }, {
    label: 'MFA for all accounts',
    description: 'Secure online accounts with OneAuth 2FA. Back up OTP secrets and never lose access to your accounts.',
    imgPath: '/api/placeholder/360/240',
    buttonText: 'Learn More',
  }, {
    label: 'MFA for all accounts',
    description: 'Secure online accounts with OneAuth 2FA. Back up OTP secrets and never lose access to your accounts.',
    imgPath: '/api/placeholder/360/240',
    buttonText: 'Learn More',
  },
];
const maxSteps = carouselItems.length;

const LoginScreen = ({ companyLogo, setPassword, setUser, password, user ,navigateToModules}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [activeStep, setActiveStep] = useState(0);
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState('');
  // const [password, setPassword] = useState('');
  const [isHovered, setIsHovered] = useState(false);

  const handleStepChange = (step) => setActiveStep(step);
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = (e) => e.preventDefault();

  return (
    <Container
      component="main"
      maxWidth="lg"
      sx={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Paper
        elevation={6}
        sx={{
          width: '100%',
          overflow: 'hidden',
          borderRadius: 4,
          transition: 'all 0.3s ease',
          '&:hover': {
            boxShadow: theme.shadows[10]
          }
        }}
      >
        <Grid container>
          {/* Left Section - Login Form */}
          <Grid item xs={12} md={6} sx={{ p: 4 }}>
            <Box sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              width: '100%',
              transition: 'all 0.3s ease'
            }}>
              <LogoText variant="h5" component="div">
                <img
                  src={companyLogo}
                  alt="Company_Logo"
                  style={{
                    padding: "0px",
                    width: "260px",
                    marginBottom: "10px",
                    marginTop: "-10px",
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'scale(1.05)'
                    }
                  }}
                />
              </LogoText>

              <Zoom in={true} timeout={500}>
                <Typography variant="h4" component="h1" sx={{ mb: 1, fontWeight: 'bold' }}>
                  Sign in
                </Typography>
              </Zoom>

              <Fade in={true} timeout={800}>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 3, fontWeight: 700 }}>
                  to access Sign
                </Typography>
              </Fade>

              <TextField
                margin="normal"
                required
                fullWidth
                id="employeeCode"
                label="Employee Code"
                name="employeeCode"
                autoComplete="username"
                variant="outlined"
                sx={{ mb: 2 }}
                value={user}
                onChange={(e) => setUser(e.target.value)}
                InputProps={{
                  sx: {
                    borderRadius: 2,
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      boxShadow: '0 0 0 2px rgba(33, 150, 243, 0.2)'
                    }
                  }
                }}
              />

              <TextField
                margin="normal"
                required
                fullWidth
                id="password"
                label="Password"
                name="password"
                type={showPassword ? 'text' : 'password'}
                autoComplete="current-password"
                variant="outlined"
                sx={{ mb: 2 }}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                InputProps={{
                  sx: {
                    borderRadius: 2,
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      boxShadow: '0 0 0 2px rgba(33, 150, 243, 0.2)'
                    }
                  },
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                        sx={{
                          color: theme.palette.grey[600],
                          '&:hover': {
                            color: theme.palette.primary.main
                          }
                        }}
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />

              <Button
                fullWidth
                variant="contained"
                sx={{
                  mt: 1,
                  mb: 2,
                  py: 1.5,
                  borderRadius: 2,
                  textTransform: 'none',
                  fontSize: '1rem',
                  fontWeight: 'bold',
                  backgroundColor: '#2196F3',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    backgroundColor: '#1976D2',
                    transform: 'translateY(-2px)',
                    boxShadow: theme.shadows[4]
                  }
                }}
                onClick={()=>{navigateToModules()}}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
              >
                {isHovered ? 'Click to Continue →' : 'NEXT'}
              </Button>

              <Fade in={true} timeout={1000}>
                <Box sx={{ width: '100%', textAlign: 'center', mb: 3 }}>
                  <Link
                    href="#"
                    variant="body2"
                    sx={{
                      color: '#2196F3',
                      textDecoration: 'none',
                      '&:hover': {
                        textDecoration: 'underline',
                        fontWeight: 'bold'
                      }
                    }}
                  >
                    Forgot Password?
                  </Link>
                </Box>
              </Fade>
            </Box>
          </Grid>

          {/* Right Section - Carousel */}
          {!isMobile && (
            <Grid
              item
              md={6}
              sx={{
                backgroundImage: 'linear-gradient(to bottom right, #1976D2, #64B5F6)',
                backgroundSize: '200% 200%',
                animation: `${waveGradient} 14s ease-in-out infinite`,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative',
                p: 4,
                overflow: 'hidden',
              }}
            >
              <AutoPlaySwipeableViews
                axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                index={activeStep}
                onChangeIndex={handleStepChange}
                enableMouseEvents
                interval={4000}
                style={{}}
              >
                {carouselItems.map((step, index) => (
                  <div key={index} style={{}}>
                    {Math.abs(activeStep - index) <= 2 ? (
                      <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        p: 2,
                        textAlign: 'center',

                      }}>
                        <Box
                          component="img"
                          sx={{

                            height: 200,
                            display: 'block',
                            overflow: 'hidden',
                            width: '100%',
                            mb: 3,
                            borderRadius: 2,
                            // boxShadow: theme.shadows[4],
                            transition: 'all 0.5s ease',
                            // '&:hover': {
                            //   transform: 'scale(1.05)'
                            // }
                          }}
                          src={step.imgPath}
                          alt={step.label}
                        />
                        <Typography
                          variant="h5"
                          align="center"
                          gutterBottom
                          sx={{
                            fontWeight: 'bold',
                            color: 'white',
                            textShadow: '0 2px 4px rgba(0,0,0,0.2)'
                          }}
                        >
                          {step.label}
                        </Typography>
                        <Typography
                          variant="body1"
                          align="center"
                          paragraph
                          sx={{
                            color: 'white',
                            mb: 3,

                            wordWrap: "break-word",
                            width: "450px"
                          }}
                        >
                          {step.description}
                        </Typography>
                        <Button
                          variant="outlined"
                          sx={{
                            mt: 2,
                            textTransform: 'none',
                            color: 'white',
                            borderColor: 'white',
                            '&:hover': {
                              backgroundColor: 'rgba(255,255,255,0.1)',
                              borderColor: 'white'
                            }
                          }}
                        >
                          {step.buttonText}
                        </Button>
                      </Box>
                    ) : null}
                  </div>
                ))}
              </AutoPlaySwipeableViews>

              <MobileStepper
                steps={maxSteps}
                position="static"
                activeStep={activeStep}
                sx={{
                  background: 'transparent',
                  width: 'auto',
                  '& .MuiMobileStepper-dot': {
                    width: 10,
                    height: 10,
                    margin: '0 6px',
                    backgroundColor: 'rgba(255,255,255,0.4)',
                    transition: 'all 0.3s ease'
                  },
                  '& .MuiMobileStepper-dotActive': {
                    backgroundColor: 'white',
                    width: 20,
                    borderRadius: 5
                  }
                }}
                nextButton={null}
                backButton={null}
              />
            </Grid>
          )}
        </Grid>
      </Paper>
    </Container>
  );
};

export default LoginScreen;